import { Link } from '@mui/material';
import { Box, styled } from '@mui/system';
import ErrorIcon from '../../../assets/insurance/error.svg';
import InProcessIcon from '../../../assets/insurance/in-process.svg';
import RetryIcon from '../../../assets/insurance/retry-icon.svg';
import SelfPayIcon from '../../../assets/insurance/self-pay.svg';
import UnknownIcon from '../../../assets/insurance/unknown.svg';
import VerifiedIcon from '../../../assets/insurance/verified.svg';

const statusIconSize = { width: '20px', height: '20px' };
const statusIconButtonStyles = {
  width: '20px',
  height: '20px',
  marginLeft: '5px',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    filter: 'brightness(140%)',
    transition: 'all 0.2s ease-in-out'
  }
};

export const StatusWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'start',
  marginTop: '10px',
  cursor: 'pointer',
  textDecoration: 'none',
  flexDirection: 'row'
});

export const CarrierName = styled('div')(() => ({
  fontSize: '14px',
  fontWeight: 400
}));

export const StatusText = styled((props: any) => <Link {...props} />)(() => ({
  fontSize: '14px',
  fontWeight: 500,
  color: 'rgba(6, 117, 221, 1)',
  transition: 'all 0.2s ease-in-out',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    color: '#089af7',
    transition: 'all 0.2s ease-in-out'
  }
}));

export const SelfPayStatus = styled((props: any) => <img src={SelfPayIcon} alt="Self Pay" {...props} />)(() => ({
  ...statusIconSize
}));

export const ManuallyVerifiedStatus = styled((props: any) => (
  <img src={VerifiedIcon} alt="Manually Verified" {...props} />
))(() => ({ ...statusIconSize }));

export const InsuranceVerifiedStatus = styled((props: any) => (
  <img src={VerifiedIcon} alt="Insurance Verified" {...props} />
))(() => ({ ...statusIconSize }));

export const InsuranceInactiveStatus = styled((props: any) => (
  <img src={ErrorIcon} alt="Insurance Inactive" {...props} />
))(() => ({ ...statusIconSize }));

export const NeedsAttentionStatus = styled((props: any) => <img src={ErrorIcon} alt="Needs Attention" {...props} />)(
  () => ({ ...statusIconSize })
);

export const VerificationErrorStatus = styled((props: any) => (
  <img src={ErrorIcon} alt="Verification Error" {...props} />
))(() => ({ ...statusIconSize }));

export const VerificationInProcessStatus = styled((props: any) => (
  <img src={InProcessIcon} alt="Verification in Process" {...props} />
))(() => ({ ...statusIconSize }));

export const RetryInProgressStatus = styled((props: any) => (
  <img src={InProcessIcon} alt="Retry in Progress" {...props} />
))(() => ({ ...statusIconSize }));

export const UnknownVerificationStatus = styled((props: any) => <img src={UnknownIcon} alt="Unknown" {...props} />)(
  () => ({ ...statusIconSize })
);

export const RetryButton = styled((props: any) => <img src={RetryIcon} alt="Retry" {...props} />)(
  () => statusIconButtonStyles
);
